// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the connect card Konvo posts in the Konvo DM when someone writes there before connecting
// an assistant (Konvo:connect embed). The nudge card's connect row on its own: Connect opens the
// Konvo panel's connect step; once connected it turns into a tick and asks for the message again.

import KonvoConnections from '@app/features/konvo_connections/state/KonvoConnections';
import {ConnectRow} from '@app/features/konvo_engagement/components/NudgeCard';
import styles from '@app/features/konvo_engagement/components/NudgeCard.module.css';
import {openNudgePanel} from '@app/features/konvo_engagement/state/NudgeActions';
import KonvoPanel from '@app/features/konvo_panel/state/KonvoPanel';
import {msg} from '@lingui/core/macro';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

const READY_DESCRIPTOR = msg({
	message: 'Your assistant is ready. Send your message again.',
	comment: 'Connect card in the Konvo DM once the assistant is connected: under "Connected".',
});

export const AssistantConnectCard = observer(function AssistantConnectCard({channelId}: {channelId: string}) {
	const connected = KonvoPanel.assistantConnected === true;

	useEffect(() => {
		if (KonvoConnections.claude == null) void KonvoConnections.refreshAssistant().catch(() => undefined);
	}, []);

	return (
		<div className={styles.wrap} data-flx="konvo-engagement.connect-card">
			<article className={styles.card}>
				<ConnectRow
					connected={connected}
					connectedDetail={READY_DESCRIPTOR}
					onConnect={() => openNudgePanel(null, channelId, undefined, 'dm_card')}
					flx="konvo-engagement.connect-card.connect"
				/>
			</article>
		</div>
	);
});
